import { supportedLocales } from '@/i18n';

export default {
  data() {
    return {
      // 支持的语言列表
      supportedLocales
    };
  },
  
  computed: {
    // 当前语言
    currentLocale() {
      return this.$i18n.locale;
    },
    
    // 当前语言名称
    currentLanguageName() {
      const current = this.supportedLocales.find(l => l.code === this.currentLocale);
      return current ? current.name : '简体中文';
    },
    
    // 是否为RTL语言
    isRTL() {
      return this.currentLocale === 'ar';
    }
  },
  
  methods: {
    // 切换语言
    changeLanguage(langCode) {
      this.$i18n.locale = langCode;
      localStorage.setItem('locale', langCode);
      
      // 设置文档方向
      if (langCode === 'ar') {
        document.documentElement.dir = 'rtl';
        document.documentElement.lang = 'ar';
      } else {
        document.documentElement.dir = 'ltr';
        document.documentElement.lang = langCode;
      }
    },
    
    // 获取语言名称
    getLanguageName(code) {
      const lang = this.supportedLocales.find(l => l.code === code);
      return lang ? lang.name : code;
    }
  }
};
